
import DefaultController from './../../../zviz2/zviz/controller';
import Group from './../../../zviz2/zviz/components/group';
import TextBox from './../../../zviz2/zviz/components/svg/textbox';
import SvgArc from './../../../zviz2/zviz/components/svg/arc';

import SVGRenderer from './../../../zviz2/zviz/renderers/svg';

import state from './../../../zviz2/zviz/state';

import Legend from './legend';


import {styleText, styleNumber} from './../../../styles';
import {formatNumber} from './../../../tools';
import {extend, rgbToHsl, hslToRgb} from './../../../zviz2/zviz/functions';



class Controller extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.type = 'svg';
        
        this.svgRenderer = new SVGRenderer();

        this.height = this.data.height || 350;
        this.width = 300;
        
        this.totalAngle = 360;
        this.dialWidth = 70;
        this.radius = 150; 
        this.setWidth();

        this.values = [];
        this.total = 0;
        
        this.legendHeight = 60;

        this.svgRenderer.start(this);

    }

    // switch renderer, because the wrong one might be passed
    // on from the parent node.
    init(renderer){

        super.init(this.svgRenderer);

        this.height = this.data.height || 350;

        if(this.parent.renderOutput.result){
            this.width = this.parent.renderOutput.result.clientWidth;
        }

        this.total = 0;
        this.values = [];
        let max = Math.max(this.data.y.length, this.data.x.length);
        for(let i = 0; i < max; i++){
            let y = this.data.y[i] || 0;
            let s = y;
            let p = (''+y).split('#');
            if(p.length > 1){
                y = parseFloat(p[0]);
                s = -1*parseFloat(p[1]);
            }
            let x = this.data.x[i] || 'unknown';
            let color = (max == this.data.color.length)? this.data.color[i]: this.getColor( (max>1? i/(max-1): 1) );
            if(! (this.data.unit[1] == '%' && y == '*')){
                this.total += y;
            }
            this.values.push({x: x, y: y, color: color, s: s});
        }
        this.values.sort(function(a, b){
            if(a.s == '*'){
                return -1;
            }
            if(b.s == '*'){
                return 1;
            }
            return (a.s - b.s);
        });
        for(let i = 0; i < this.values.length; i++){
            if(this.values[i].y == '*'){
                this.values[i].y = 100 - this.total;
                this.total = 100;
            }
        }

    }

    render(renderer){
        super.render(this.svgRenderer);
        if(state.forceGlobalUpdate){
            this.setWidth();
        }
    }

    remove(renderer, removeFromParent=true){
        super.remove(this.svgRenderer, removeFromParent);
        this.svgRenderer.remove(false);
    }

    changeWidth(){
        this.setWidth();
        this.update();
    }

    setWidth(){
        if(this.parent.renderOutput.result){
            this.width = this.parent.renderOutput.result.clientWidth;
        }
        this.radius = this.width/2.4;
        this.dialWidth = this.radius / 2.2;
        if((this.radius - this.dialWidth) < 50){
            this.dialWidth = 30;
        }
    }


    getColor(s){
        let c = this.data.color;
        if(c.length == 1){
            let hsl = rgbToHsl(c[0]);

            let m = 0.1
            let p = 0.3
            if(hsl[2] > 0.4){
                m = 0.2;
                p = 0.2;
            }else if(hsl[2] < 0.25){
                m = 0;
                p = 0.4;
            }

            c = [ 
                hslToRgb([360*hsl[0], 100*hsl[1], 100*Math.max(0, hsl[2]-m)]), 
                hslToRgb([360*hsl[0], 100*hsl[1], 100*Math.min(1, hsl[2]+p)]) 
            ];
        }
        
        return [
            Math.round(c[0][0] + s*(c[1][0]-c[0][0])),
            Math.round(c[0][1] + s*(c[1][1]-c[0][1])),
            Math.round(c[0][2] + s*(c[1][2]-c[0][2]))
        ];
    }


    getTotalAmount(line){
        let r = formatNumber(this.total, this.data.numberFormat, this.data.decimals);
        let p = r.split(' ');
        if(p[line-1]){
            if(p[0]=='100' && this.data.unit[1]=='%'){
                return '%';
            }
            return p[line-1];
        }
        return null;
    }

    getUnit(axis){
        if(axis=='y'){
            if(this.total == 100){
                return false;
            }
            return this.data.unit[1] || false;
        }
        return this.data.unit[0] || false;
    }


    getDistCenter(){
        let w = window.innerWidth || 1200;
        if(w-4*this.radius < 300){
            return 0.35*this.radius;
        }
        return 0.9*this.radius;
    }

    getParts(){
        
        let result = [];
        let curAngle = 359.9;

        for(let i = 0; i < this.values.length; i++){

            let perc = this.values[i].y / this.total;
            let percDisplay = 0;
            if((this.values[i].y && this.total)){
                percDisplay = Math.round(100 * this.values[i].y / this.total);
                if(percDisplay == 0){
                    percDisplay = (100 * this.values[i].y / this.total).toFixed(1);
                    if(percDisplay == '0.0'){
                        percDisplay = (100 * this.values[i].y / this.total).toFixed(2);
                    }
                }
            }
            let val = formatNumber(this.values[i].y, this.data.numberFormat, this.data.decimals);
            let unit = this.getUnit('y');
            val += unit? ' ' + unit: '';
            val += ' (' + percDisplay + '%)';

            result.push(extend({
                properties: {
                    data: {
                        x: 0,
                        y: 0,
                        radius: this.radius,
                        innerRadius: this.radius - this.dialWidth,
                        a1: Math.max(0, curAngle - (perc * 360)),
                        a2: curAngle,
                        label: this.values[i].x,
                        value: val
                    },
                    style: {
                        fill: 'rgb(' + this.values[i].color.join(',') +')',
                        stroke: 'rgba(255,255,255,1)',
                        strokeWidth: '2px'
                    },
                    transform: {
                        position: {
                            x: (ctrl) => (0.5*ctrl.parent.width),
                            y: (ctrl) => (0.5*ctrl.parent.height)
                        },
                    }
                },
                events: {
                    mouseover: (event, ctrl) => {
                        state.set('tooltip', [ '*'+ctrl.data.label, ctrl.data.value]);
                    },
                    mouseout: (event, ctrl) => { state.set('tooltip', null); }
                }
            }, SvgArc));

            curAngle -= perc * 360;

        }

        return result;
    }

    setLegendHeight(height=0){
        if(this.data.linkedDonutId){
            let h = state.get(this.data.linkedDonutId);
            height = Math.max(height, h);
            state.set(this.data.linkedDonutId, height);
        }
        this.legendHeight = height;
        this.height = Math.max(this.height, this.legendHeight+2*this.radius+60);
        this.update();
    }

} 



let Blueprint = {
    type: Controller,
    properties: {
        attributes: {
            'width': (ctrl) => ( ctrl.width + 'px' ),
            'height': (ctrl) => ( (ctrl.height) + 'px' ), 
            'viewbox': (ctrl) => ( '0 0 ' + ctrl.width + 
                    ' ' + (ctrl.height) )
        },
        data: {
            color: [ [50,50,50], [ 120, 120, 120] ],
            dimension: ['', ''],
            unit: ['', ''],
            x: [],
            y: [],
            decimals: 1,
            numberFormat: 'english',
            linkedDonutId: false
        } 
    },
    listeners: [
        (ctrl) => ( (ctrl.data.linkedDonutId)? ctrl.addListener(state, [ctrl, ctrl.setLegendHeight], ctrl.data.linkedDonutId): null ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.changeWidth], 'windowSize.width') )
    ],
    children: [ 

        (parent) => (extend({
            properties: {
                data: {
                    values: parent.values.slice(0),
                    width: parent.width,
                    total: parent.total
                },
            },
            responders: [
                {name: 'legendHeight', callback: [parent, parent.setLegendHeight] },
            ]
        }, Legend) ),

        (parent) => (extend({
            properties: {
                transform: {
                    position: {
                        x: (ctrl) => (0.5*ctrl.parent.width),
                        y: (ctrl) => (ctrl.parent.radius + 30 + ctrl.parent.legendHeight)
                    }
                },
                data: {
                    legendHeight: state.get(parent.data.linkedDonutId)
                }
            }, 
            children: [
                (parent) => ( parent.parent.getParts() ),

                (parent) => (extend({
                    properties: {
                        transform: {
                            position: {
                                x: -1*(parent.parent.radius - parent.parent.dialWidth),
                                y: (parent.parent.getTotalAmount(2) || parent.parent.getUnit('y'))? -10: 5
                            }
                        },
                        style: extend({
                            
                        }, styleNumber),
                        data: {
                            alignment: 'center',
                            width: 2*(parent.parent.radius - parent.parent.dialWidth),
                            text: parent.parent.getTotalAmount(1)
                        }
                    }
                }, TextBox) ),

                (parent) => (parent.parent.getTotalAmount(2)? extend({
                    properties: {
                        transform: {
                            position: {
                                x: -1*(parent.parent.radius - parent.parent.dialWidth),
                                y: 10
                            }
                        },
                        style: extend({
                            fontWeight: 'bold',
                            fill: '#515151',
                        }, styleText),
                        data: {
                            alignment: 'center',
                            width: 2*(parent.parent.radius - parent.parent.dialWidth),
                            text: parent.parent.getTotalAmount(2)
                        }
                    }
                }, TextBox): [] ),

                (parent) => (parent.parent.getUnit('y')? extend({
                    properties: {
                         transform: {
                            position: {
                                x: -1*(parent.parent.radius - parent.parent.dialWidth),
                                y: parent.parent.getTotalAmount(2)? 30: 10
                            }
                        },
                        style: extend({
                        }, styleText),
                        data: {
                            alignment: 'center',
                            width: 2*(parent.parent.radius - parent.parent.dialWidth),
                            text: '(' + parent.parent.getUnit('y') + ')'
                        }
                    }
                }, TextBox): [] ),
                
            ]
        }, Group) ),


        
    ]
};




export default Blueprint;
export {Controller, Blueprint};

